<template>
  <div>
    <particlesHeader :Title="'Mahmoud Salameh'" :Size="13" />
    <section class="content-section">
      <div class="container">
        <div class="row">
          <div class="col-md-5 centered col-sm-12 padded-with-20">
            <div class="box-container glass-background">
              <div class="image-wrapper">
                <img class="responsive about-box-image" src="../assets/home/front.png" />
              </div>
              <p class="about-box-description">
                I can be responsible for implementing visual and interactive
                elements
                that
                users engage with through their web browser when using a web
                application
              </p>
            </div>
          </div>

          <div class="col-md-5 centered col-sm-12 padded-with-20">
            <div class="box-container glass-background">
              <div class="image-wrapper">
                <img class="responsive about-box-image" src="../assets/home/back.png" />
              </div>
              <p class="about-box-description">
                I can do server-side web application logic and
                integration
                with front-end side. I'm
                usually writing the web services and APIs used by client apps to
                serve the buisness logic
              </p>
            </div>
          </div>

          <div class="col-md-11 centered col-sm-12 self-description-quote">
            <div class="container glass-background">
              <div class="row padded-with-40px">
                <div class="col-md-12">
                  I am an optimistic, candid, responsible and social person. I am
                  confident with my thinking analysis that I can convince people with my
                  points. I am self-reliant, well behaved and above all. I take
                  initiative whenever the situation arises and
                  come off with flying colours
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pageInlineNavigation :Next="'Achievments'" :back="null" />
    </section>
  </div>
</template>

<script>
import particlesHeader from "../components/particlesHeader";
import pageInlineNavigation from "../components/pageInlineNavigation";
export default {
  components: {
    particlesHeader,
    pageInlineNavigation,
  },

  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.box-container {
  padding: 10px;
  height: 100%;
}
.image-wrapper {
  width: 45px;
  margin: 0 auto;
  margin-top: 15px;
}

.about-box-image {
  max-width: 100%;
  max-height: 100%;
}

.about-box-description {
  padding: 8px;
  color: #f7f7f7;
  text-align: justify;
  font-size: 14px;
  margin-top: 20px;
}

.self-description-quote {
  margin-top: 55px;
}

.about-box-header {
  margin-left: auto;
  margin-right: auto;
}

.quotation-image {
  margin-top: 10px;
}

@media (min-width: 481px) and (max-width: 767px),
  (min-width: 320px) and (max-width: 480px),
  (min-width: 768px) and (max-width: 1024px) {
  .quotation-image {
    margin-top: 10px;
    height: 35px;
    margin-bottom: 22px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  .first-box {
    margin-top: 0px;
  }
}
</style>